import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UserService} from "../../../../@shared/services/user.service";
import {Subject} from "rxjs";
import {IWelcomeCaseProgress} from "../services/interfaces/welcome-case-progress.interface";
import {takeUntil} from "rxjs/operators";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";

@Component({
  selector: 'app-welcome-cases',
  templateUrl: './welcome-cases.component.html',
  styleUrls: ['./welcome-cases.component.scss']
})
export class WelcomeCasesComponent implements OnDestroy, AfterViewInit {
  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild('welcomeCaseTable', {read: MatSort, static: true}) welcomeCaseTable: MatSort;

  public welcomeCaseColumns: string[] = ['count', 'action', 'status', 'progress', 'caseSet', 'data'];
  public welcomeCaseDataSource: MatTableDataSource<IWelcomeCaseProgress> = new MatTableDataSource();
  public destroyed$: Subject<void> = new Subject<void>();
  public isLoading: boolean = false;

  constructor(private userService: UserService) {
    this.subscribeEmitters();
  }

  ngAfterViewInit() {
    this.welcomeCaseDataSource.paginator = this.paginator;
    this.welcomeCaseDataSource.sort = this.welcomeCaseTable;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private subscribeEmitters() {
    this.userService.getUserWelcomeCases()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((welcomeCases: IWelcomeCaseProgress[]) => {
        this.welcomeCaseDataSource.data = welcomeCases;
      });
  }

}
